interface Props {
  children: React.ReactNode;
}

const CardHeader = ({ children }: Props) => {
  return (
    <div className='px-4 py-5 sm:px-6'>
      <div className='-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap'>
        {children}
      </div>
    </div>
  );
};
export default CardHeader;
